/** EN uses Swedish values until translated. */
export const pagesWarrantsEn = {
    filters: {
        onlyInTheMoney: 'Show only TO in the money',
        onlyOutOfTheMoney: 'Show only TO out of the money',
        onlyFloatingPrice: 'Show only TO with variable price',
        onlyFixedPrice: 'Show only TO with fixed price',
        unlistedLabel: 'Unlisted',
        inTheMoneyLabel: 'In the money',
    },
    status: {
        label: 'Status:',
        cancelled: 'Cancelled',
        upcoming: 'Upcoming',
        completed: 'Completed',
        ongoingSubscription: 'Ongoing exercise period',
    },
    cancelledNotice: 'Please note that this warrant has been cancelled. The content presented below reflects the information that was available to the market.',
    sections: {
        origin: 'The origin of the warrant',
        terms: 'Terms',
        subscribersAndGuarantors: 'Sub commitment and guarantors',
        outcome: 'Outcome',
        tradingStats: 'Trade statistics',
        other: 'Other',
    },
    summary: {
        title: 'Summary',
    },
    firstTradingDay: 'First trading day',
    tradingNotStarted: 'Trading not started',
    unlisted: 'Unlisted',
    lastSubscriptionDay: 'Last day to subscribe',
    subscriptionPeriod: 'Subscription period',
    ratio: 'Ratio',
    currentSharePrice: 'Current share price',
    amountAtFullUtilization: 'Amount at full subscription',
    pricing: 'Pricing',
    secured: 'Secured',
    subscriptionCommitment: 'Sub commitments:',
    guarantorCommitment: 'Guarantors:',
    shareSingular: 'share',
    sharePlural: 'shares',
    warrantSingular: 'TO',
    warrantPlural: 'TO',
    preliminaryOneDay: '* Preliminary based on last trading day',
    preliminaryDays: '* Preliminary based on the last {{n}} trading days',
    noSubscriptionPeriods: 'No underlying periods found',
    showingPeriod: 'Showing period {{current}} of total {{total}} subscription periods.',
    directedIssueToGuarantors: 'Directed issue to guarantors',
    guarantorRemunerationShares: 'Fee in shares to guarantors',
    origin: {
        label: 'Origin',
        numberOfWarrants: 'Number of warrants',
    },
    tradingStats: {
        columns: {
            time: 'Time',
            vwap: 'VWAP',
            tradedCount: 'TO amount traded',
            tradedShare: 'TO ratio traded',
            turnoverPerDay: 'Turnover / day',
        },
        sinceTradingStarted: 'Since trading started',
        lastTenDays: 'Last ten trading days',
        latestDay: 'Last trading day',
    },
    otherInfo: {
        priceAdjustment: 'In the event of any new share issues before the start of the subscription period, the subscription price shall be adjusted to the issue price.',
    },
}
